import axios from "axios";
import { endpoint } from "../../config";
import { customToast } from "../../lib/toastLib";

const plansApi = async () => {
  try {
    const apiLink = `${endpoint}/api/plan`;
    const response = await axios.get(apiLink);
    const data = response.data;

    const dataArray = [];
    if (data) {
      data.forEach((elem) => {
        const obj = {
          id: elem.id,
          planName: elem.name || "",
          planDescription: elem.description || "",
          planPrice: elem.price || "",
          planCurrecyIsoCode: elem.currecyIsoCode || "",
          planBillingInterval: elem.billingInterval,
          planStripePriceId: elem.stripePriceId || "",
          planStripeProductId: elem.stripeProductId || "",
        };
        dataArray.push(obj);
      });
    }

    return dataArray;
  } catch (error) {
    if (error.response) {
      customToast.error(error.response.data?.message);
    } else {
      customToast.error(error.message);
    }
    throw error;
  }
};

export default plansApi;
